import { render } from "./RichEditor.vue?vue&type=template&id=b5c7a5a2&scoped=true"
import script from "./RichEditor.vue?vue&type=script&lang=js"
export * from "./RichEditor.vue?vue&type=script&lang=js"

import "./RichEditor.vue?vue&type=style&index=0&id=b5c7a5a2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c7a5a2"]])

export default __exports__